/**
 * Uploaded PowerPoint templates ("masters", pd7 CONTRACT §1.4, §2.4): the limits and error codes
 * api-service answers with, and what the file input offers. The wire shapes
 * (`DistributionMasterUploadApi`, `DistributionMasterLookApi`) are in distributions.types.ts.
 */

export const MASTER_LIMITS = {
  /** 25 MB as api-service counts it (`413 master_too_large` above). */
  maxBytes: 26_214_400,
  /** File name extensions the picker offers; api-service decides by the bytes, not the name. */
  extensions: ["pptx", "potx"],
} as const;

export const MASTER_ERROR_CODES = {
  tooLarge: "master_too_large",
  notPptx: "master_not_pptx",
} as const;

/**
 * This deployment has no bucket for uploads. api-service words that for operators (every 5xx is
 * `internal_error`), so the state is keyed on the status, like brand kit logos.
 */
export const MASTER_UPLOADS_UNAVAILABLE_STATUS = 503;

/** The file input's `accept`: both extensions and their MIME types. */
export const MASTER_FILE_ACCEPT = [
  ".pptx",
  ".potx",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.template",
].join(",");

/** The slide kinds the reader matches one of the upload's layouts to, in the order a deck uses them. */
export const MASTER_SLIDE_KINDS = [
  "cover_open",
  "story_summary",
  "kpi_row3",
  "chart_full",
  "chart_split",
  "text_body",
  "cover_close",
] as const;
